/**
 * Stacking order for everything that floats above the page.
 *
 * Popovers sit above modals on purpose: a select or tag picker opened from inside a modal must
 * render over it. Tooltips win over both because they can be triggered from either.
 */
export const LAYER = {
	dropdown: 'z-[1000]',
	modal: 'z-[1100]',
	popover: 'z-[1200]',
	tooltip: 'z-[1300]',
	// Toasts report the outcome of an action taken in a dialog, so they outrank every surface.
	toast: 'z-[1400]',
};
